import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  Companion_getInstance2jahap30xtp3t as Companion_getInstance,
  toDuration7gy6v749ektt as toDuration,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_MILLISECONDS_getInstancedq9xrzm1t8sm as DurationUnit_MILLISECONDS_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Companion_getInstance23x6zslwzj0st as Companion_getInstance_0 } from '../../models/data.mjs';
import { Action2nhdpxpznfsbd as Action } from '../../reactive/Action.mjs';
import {
  $3l5vvh8yg0ier as $,
  orPromise1iucc2to2udt2 as orPromise,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function onClick(_this__u8e3s4, label, icon, frequencyCap, action) {
  label = label === VOID ? null : label;
  icon = icon === VOID ? null : icon;
  var tmp;
  if (frequencyCap === VOID) {
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    tmp = toDuration(500, DurationUnit_MILLISECONDS_getInstance());
  } else {
    tmp = frequencyCap;
  }
  frequencyCap = tmp;
  var tmp_0 = label == null ? '' : label;
  var tmp_1 = icon == null ? Companion_getInstance_0().send_1 : icon;
  _this__u8e3s4.set_action_2ds022_k$(Action(tmp_0, tmp_1, VOID, VOID, frequencyCap, VOID, onClick$slambda(action)));
}
function onClick$slambda($action) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    yield* $($action($completion), $completion);
    return Unit_instance;
  }), 1);
}
//region block: exports
export {
  onClick as onClick3gjrd4jjo1cak,
};
//endregion

//# sourceMappingURL=Button.mjs.map
